import { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ThemeProvider, useTheme } from 'styled-components';
import { darkColors, Modal, StyledButton } from '@tryhackme/thm-ui-components';
import { usePricing } from 'src/common/hooks';
import { useCampaignStorage } from 'src/features/campaigns/hooks/use-campaign-storage';
import { useTrackEventMutation } from 'src/common/slices';
import { StarWarsSaber } from '../star-wars-saber';
import { Countdown } from '../../components/countdown/countdown';
import { useCampaignCta } from '../../hooks/use-campaign-cta';
import { useActiveCampaign } from '../../hooks/use-active-campaign';
import { useAbsoluteSavingAmount } from '../../hooks/use-absolute-saving-amount';
import { Benefits } from './components/benefits';
import { StyledContent, StyledCenteredContent, StyledHeading, StyledSubTitle, StyledButtons, StyledSaber } from './star-wars-modal.styles';
import { DiscountMessage } from './components/discount-message';
export const StarWarsModal: FC = () => {
  const theme = useTheme();
  const {
    price: priceStr,
    symbol
  } = usePricing(true);
  const [trackEvent] = useTrackEventMutation();
  const {
    campaign
  } = useActiveCampaign();
  const {
    isSeen,
    markAsSeen
  } = useCampaignStorage(campaign);
  const [ctaText, urlToNavigate] = useCampaignCta();
  const absoluteSaving = useAbsoluteSavingAmount(campaign);
  const [open, setOpen] = useState(!isSeen);
  const price = Number.parseFloat(priceStr);
  const discountedPrice = price * (100 - (campaign?.amount ?? 0)) / 100;
  useEffect(() => {
    if (isSeen) {
      setOpen(false);
    }
  }, [isSeen]);
  const onOpenChange = (isOpen: boolean) => {
    if (isOpen) return;
    markAsSeen();
    setOpen(false);
  };
  const onCtaClick = () => {
    markAsSeen();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    trackEvent({
      event: 'click-subscribe-now',
      properties: {
        'clicked-on': 'dashboard-pop-up'
      }
    });
  };
  return campaign ? <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }}>
      <Modal padding="0" open={open} onOpenChange={onOpenChange} preventCloseOnOutsideClick>
        <StyledContent>
          <StyledSaber>
            <StarWarsSaber red />
          </StyledSaber>
          <StyledSaber onRight>
            <StarWarsSaber />
          </StyledSaber>

          <StyledCenteredContent>
            <StyledHeading data-testid="campaign-title">
              MAY THE 4<sup>TH</sup> BE WITH YOU
            </StyledHeading>
            <StyledSubTitle data-testid="campaign-promotion-text">
              {absoluteSaving ? <>
                  Save <span>{absoluteSaving}</span> on annual subscriptions
                </> : <>
                  <span>{campaign.amount}% off</span> TryHackMe annual subscriptions
                </>}
            </StyledSubTitle>
          </StyledCenteredContent>
          <Countdown includeDays vertical dark startTime={campaign.startTime} endTime={campaign.endTime} />
          <Benefits />
          <DiscountMessage price={price} discountedPrice={discountedPrice} symbol={symbol} />
          <StyledButtons>
            <StyledButton as={Link} role="button" to={urlToNavigate} aria-label="Subscribe now" variant="solid" color="primary" onClick={onCtaClick}>
              {ctaText}
            </StyledButton>
          </StyledButtons>
        </StyledContent>
      </Modal>
    </ThemeProvider> : null;
};